/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { unproxiedMcpListServers } from "../funcs/unproxiedMcpListServers.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListUnproxiedMcpServersResult } from "../models/components/listunproxiedmcpserversresult.js";
import {
  ListUnproxiedMcpServersRequest,
  ListUnproxiedMcpServersSecurity,
} from "../models/operations/listunproxiedmcpservers.js";
import { unwrapAsync } from "../types/fp.js";
export type UnproxiedMcpServersQueryData = ListUnproxiedMcpServersResult;

export function prefetchUnproxiedMcpServers(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListUnproxiedMcpServersRequest | undefined,
  security?: ListUnproxiedMcpServersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildUnproxiedMcpServersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildUnproxiedMcpServersQuery(
  client$: GramCore,
  request?: ListUnproxiedMcpServersRequest | undefined,
  security?: ListUnproxiedMcpServersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<UnproxiedMcpServersQueryData>;
} {
  return {
    queryKey: queryKeyUnproxiedMcpServers({
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function unproxiedMcpServersQueryFn(
      ctx,
    ): Promise<UnproxiedMcpServersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(unproxiedMcpListServers(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyUnproxiedMcpServers(
  parameters: {
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "unproxiedMcp", "listServers", parameters];
}
